// Payments queue, subscriptions (site panel, expiring list, compliance log) and the billing setting.
export const billingEn = {
  'shell.nav.payments': 'Payments',
  'pay.title': 'Payments',
  'pay.subtitle': 'Renewal payments sent from the sites’ CMS, subscriptions that need attention, and the bank account clients pay into.',
  'pay.queue': 'Waiting for confirmation',
  'pay.queueEmpty': 'No payments are waiting.',
  'pay.site': 'Site',
  'pay.months': 'Months',
  'pay.amount': 'Amount',
  'pay.sent': 'Sent',
  'pay.by': 'By',
  'pay.proof': 'Proof',
  'pay.openProof': 'Open proof',
  'pay.openPdf': 'Open PDF',
  'pay.approve': 'Approve',
  'pay.reject': 'Reject',
  'pay.approveTitle': 'Approve this payment?',
  'pay.approveBody': '{site}: {amount} for {months} month(s). Paid-until moves {months} month(s) on from today or from the current paid-until date, whichever is later, and a receipt is issued.',
  'pay.approved': 'Approved: receipt {receipt}',
  'pay.rejectTitle': 'Reject this payment',
  'pay.reason': 'Reason (the client sees it)',
  'pay.rejected': 'Payment rejected',
  'pay.siteLater': 'Saved. The site could not be told yet ({error}); it gets the change on its next sync.',
  'pay.decided': 'Decided payments',
  'pay.decidedEmpty': 'No decided payments yet.',
  'pay.status': 'Status',
  'pay.status.pending': 'Waiting',
  'pay.status.approved': 'Approved',
  'pay.status.rejected': 'Rejected',
  'pay.period': 'Period',
  'pay.receipt': 'Receipt',
  'pay.download': 'Download',
  'pay.notSynced': 'not on the site yet',
  'pay.expiring': 'Expiring and expired',
  'pay.expiringHint': 'Ending within 14 days or already ended, and sites without a subscription set up.',
  'pay.expiringEmpty': 'Every subscription runs for more than 14 days.',
  'pay.paidUntil': 'Paid until',
  'pay.daysLeft': 'Days left',
  'pay.stage': 'Stage',
  'pay.log': 'Compliance log',
  'pay.logHint': 'Every approval, rejection and manual change. Lines are never edited or deleted.',
  'pay.logEmpty': 'Nothing yet.',
  'pay.log.when': 'When',
  'pay.log.who': 'Who',
  'pay.log.what': 'What',
  'pay.log.change': 'Paid until',
  'pay.log.proof': 'Proof (SHA-256)',
  'pay.log.action.approve': 'Approved',
  'pay.log.action.reject': 'Rejected',
  'pay.log.action.manual': 'Manual change',
  'pay.bank': 'Bank account',
  'pay.bankHint': 'Shown to clients when they renew in their CMS.',
  'pay.bank.bank': 'Bank',
  'pay.bank.number': 'Account number',
  'pay.bank.name': 'Account name',
  'pay.bankSaved': 'Bank account saved',
  'stage.none': 'Not set up',
  'stage.exempt': 'No subscription',
  'stage.active': 'Active',
  'stage.reminder': 'Ends soon',
  'stage.grace': 'Grace period',
  'stage.readonly': 'CMS read-only',
  'stage.maintenance': 'Maintenance page',
  'stage.off': 'Site off',
  'sub.panel': 'Subscription',
  'sub.panelHint': 'Set what the client agreed to. Approved payments move the paid-until date; a change here is logged.',
  'sub.exempt': 'No subscription needed (demo site, our own CMS)',
  'sub.package': 'Package',
  'sub.price': 'Price per month (Rp)',
  'sub.start': 'Start date',
  'sub.paidUntil': 'Paid until (last paid day)',
  'sub.save': 'Save subscription',
  'sub.saved': 'Subscription saved',
  'sub.stageNow': 'Now: {stage}',
  'sub.daysLeft': '{n} day(s) left',
  'sub.daysOver': 'ended {n} day(s) ago',
  'sub.payments': 'Payments of this site',
} as const

export const billingId: Record<keyof typeof billingEn, string> = {
  'shell.nav.payments': 'Pembayaran',
  'pay.title': 'Pembayaran',
  'pay.subtitle': 'Pembayaran perpanjangan dari CMS setiap situs, langganan yang perlu ditindaklanjuti, dan rekening tujuan transfer klien.',
  'pay.queue': 'Menunggu konfirmasi',
  'pay.queueEmpty': 'Tidak ada pembayaran yang menunggu.',
  'pay.site': 'Situs',
  'pay.months': 'Bulan',
  'pay.amount': 'Jumlah',
  'pay.sent': 'Dikirim',
  'pay.by': 'Oleh',
  'pay.proof': 'Bukti',
  'pay.openProof': 'Buka bukti',
  'pay.openPdf': 'Buka PDF',
  'pay.approve': 'Setujui',
  'pay.reject': 'Tolak',
  'pay.approveTitle': 'Setujui pembayaran ini?',
  'pay.approveBody': '{site}: {amount} untuk {months} bulan. Masa aktif diperpanjang {months} bulan dari hari ini atau dari tanggal aktif sekarang, mana yang lebih akhir, dan kwitansi diterbitkan.',
  'pay.approved': 'Disetujui: kwitansi {receipt}',
  'pay.rejectTitle': 'Tolak pembayaran ini',
  'pay.reason': 'Alasan (dibaca klien)',
  'pay.rejected': 'Pembayaran ditolak',
  'pay.siteLater': 'Tersimpan. Situs belum bisa diberi tahu ({error}); perubahan dikirim saat sinkronisasi berikutnya.',
  'pay.decided': 'Pembayaran yang sudah diputuskan',
  'pay.decidedEmpty': 'Belum ada.',
  'pay.status': 'Status',
  'pay.status.pending': 'Menunggu',
  'pay.status.approved': 'Disetujui',
  'pay.status.rejected': 'Ditolak',
  'pay.period': 'Periode',
  'pay.receipt': 'Kwitansi',
  'pay.download': 'Unduh',
  'pay.notSynced': 'belum sampai di situs',
  'pay.expiring': 'Segera berakhir dan sudah berakhir',
  'pay.expiringHint': 'Berakhir dalam 14 hari atau sudah berakhir, dan situs yang langganannya belum diatur.',
  'pay.expiringEmpty': 'Semua langganan masih berjalan lebih dari 14 hari.',
  'pay.paidUntil': 'Aktif sampai',
  'pay.daysLeft': 'Sisa hari',
  'pay.stage': 'Tahap',
  'pay.log': 'Log kepatuhan',
  'pay.logHint': 'Setiap persetujuan, penolakan, dan perubahan manual. Baris tidak pernah diubah atau dihapus.',
  'pay.logEmpty': 'Belum ada.',
  'pay.log.when': 'Kapan',
  'pay.log.who': 'Siapa',
  'pay.log.what': 'Apa',
  'pay.log.change': 'Aktif sampai',
  'pay.log.proof': 'Bukti (SHA-256)',
  'pay.log.action.approve': 'Disetujui',
  'pay.log.action.reject': 'Ditolak',
  'pay.log.action.manual': 'Perubahan manual',
  'pay.bank': 'Rekening bank',
  'pay.bankHint': 'Ditampilkan ke klien saat memperpanjang di CMS.',
  'pay.bank.bank': 'Bank',
  'pay.bank.number': 'Nomor rekening',
  'pay.bank.name': 'Atas nama',
  'pay.bankSaved': 'Rekening disimpan',
  'stage.none': 'Belum diatur',
  'stage.exempt': 'Tanpa langganan',
  'stage.active': 'Aktif',
  'stage.reminder': 'Segera berakhir',
  'stage.grace': 'Masa tenggang',
  'stage.readonly': 'CMS hanya baca',
  'stage.maintenance': 'Halaman pemeliharaan',
  'stage.off': 'Situs nonaktif',
  'sub.panel': 'Langganan',
  'sub.panelHint': 'Isi sesuai kesepakatan dengan klien. Pembayaran yang disetujui menggeser tanggal aktif; perubahan di sini dicatat.',
  'sub.exempt': 'Tidak perlu langganan (situs demo, CMS kita sendiri)',
  'sub.package': 'Paket',
  'sub.price': 'Harga per bulan (Rp)',
  'sub.start': 'Tanggal mulai',
  'sub.paidUntil': 'Aktif sampai (hari terakhir yang dibayar)',
  'sub.save': 'Simpan langganan',
  'sub.saved': 'Langganan disimpan',
  'sub.stageNow': 'Sekarang: {stage}',
  'sub.daysLeft': 'sisa {n} hari',
  'sub.daysOver': 'berakhir {n} hari lalu',
  'sub.payments': 'Pembayaran situs ini',
}
